import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="design-iconfont"
    >
      <path
        d="M13.1818182,1.92590908 L6.81818182,3.66136363 L6.81818182,18.0740909 L13.1818182,16.3386364 L13.1818182,1.92590908 Z M0,0 L6.66681818,1.81818182 L13.3331818,0 L20,1.81818182 L20,20 L13.3331818,18.1818182 L6.66681818,20 L0,18.1818182 L0,0 Z"
        fill="#00A870"
        fillRule="nonzero"
      />
    </svg>
  )
}

const SpecialColumnIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default SpecialColumnIcon
